import React from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import Logo from '../Components/Logo';
import Loading from '../Components/Loading';

import PDConsent from '../Components/EssentialDataComponents/PDConsent';
import { AddNewSignatureComponent } from '../Components/AddNewSignatureComponent';
import { AddNewVerificationCodeComponent } from '../Components/AddNewVerificationCodeComponent';

import styles from '../styles/DynamicModal.module.css';
import stylesLogo from '../styles/Logo.module.css';

export default function EssentialDataModal({ userId }) {
    const navigate = useNavigate();

    const [loading, setLoading] = React.useState(true);
    const [isSignature, setIsSignature] = React.useState(true);
    const [isPDConsent, setIsPDConsent] = React.useState(true);
    const [isVerificationCode, setIsVerificationCode] = React.useState(true);

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get('/api/get-essential-account-data', {
            headers: { Authorization: `Bearer ${token}` }
        })
        .then((response) => {
            const data = response.data;
            setIsSignature(data.is_signature);
            setIsPDConsent(data.is_pd_consent);
            setIsVerificationCode(data.verification_code);
        })
        .catch((error) => {
            console.error('Ошибка при получении данных пользователя:', error);
            navigate('/');
        })
        .finally(() => {
            setLoading(false);
        });
    }, []);

    return (
    <>
        <a style={{zIndex: '9999'}} className={stylesLogo.widthLimitation}><Logo to='/' position='fixed' /></a>

        <div className={styles.liningOver} style={{backgroundColor: 'inherit'}} onClick={() => navigate('/')}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>Перед использованием системы</h1>
                    <div
                        className='horizontalContainer'
                    >
                        <button
                            className='tableButton'
                            onClick={() => navigate('/send-feedback')}
                        >
                            Обратиться в поддержку
                        </button>
                        <button
                            className='tableButton red'
                            onClick={() => navigate('/auth/logout')}
                        >
                            Выйти из аккаунта
                        </button>
                    </div>
                </div>
                <div className={styles.main}>
                    {loading ? <Loading /> : 
                    <>
                        {!isPDConsent && <PDConsent isSignature={isSignature} />}
                        {!isSignature && <AddNewSignatureComponent userId={userId} />}
                        {!isVerificationCode && <AddNewVerificationCodeComponent />}
                    </>}
                </div>
            </div>
        </div>
    </>
    )
};
